const TEAM_HEADERS = [
  {
    name: 'Name',
    column: 'name'
  },

  {
    name: 'Email',
    column: 'email'
  },
  {
    name: 'Role',
    column: 'role'
  },
  {
    name: 'Member Status',
    column: 'status'
  },
  {
    name: 'Last Login',
    column: 'last_login'
  },
  {
    name: 'Actions',
    column: 'action'
  }
];

export { TEAM_HEADERS };
